export const ACTIONS = {
  VISIT__SLOT_CHOICE: 'visit--slot-choice',
  VISIT__FEEDBACK: 'visit--feedback',
  DEAL__ARCHIVE: 'deal--archive',
  DEAL__ARCHIVE_UI: 'deal--archive-ui',
  DEAL__IN_PROGRESS: 'deal--in-progress',
  DEAL__SIGNED: 'deal--signed',
  DEAL__UNSIGNED: 'deal--unsigned',
};

// All those events are triggered by an action component.
// They are caught by the CardActionsContainer.
// CardActionsContainer will trigger new events to the dashboard.
export const EVENTS = {
  // Triggered when an action is cancelled or when the user quits/closes the slide-in/up.
  ACTION_CANCELLED: 'action-cancelled',
  // Triggered by the action component when the user completes the action normally, without exiting.
  ACTION_PERFORMED: 'action-performed',
  // Triggered by the action component to set the slide-in/up title.
  TITLE_UPDATE: 'title-update',
};
